@import 'ss-ui-client/src/constants/spacing.module.less';

.editor {
  padding: @space-16;
  background: var(--grey-50);
  border-radius: 4px;
  border: 1px solid var(--grey-300);
}

.filter-row {
  display: grid;
  grid-template-columns: 30% 30% 30% 4%;
  align-items: center;
  background-color: var(--default--background-color--1);
  border-radius: 4px;
  padding: @space-8;
}

.action-row {
  display: flex;
  flex-wrap: wrap;
  background-color: var(--default--background-color--1);
  padding: @space-8;
  border-radius: 4px;
}

.action-properties {
  display: grid;
  grid-template-columns: 50% 50%;
  width: calc(100% - 40px);
  align-items: center;
  gap: @space-8;
}

.remove-button-container {
  display: flex;
  align-items: center;
}

.remove-button {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--grey-600);
  font-size: 18px;
  flex-shrink: 0;

  &:hover {
    color: var(--red-500);
    background: var(--grey-100);
    border-radius: 4px;
  }
}
